
import { Outlet, Link, useNavigate } from 'react-router-dom';


export const CLOSEDDATA = [{startdate:"2026-05-01T14:00:00", enddate:"2026-05-01T19:00:00"}, 
  {startdate:"2026-05-02T00:00", enddate:"2026-05-04T00:00"}];

export const TIMEDATA = ("09:00,10:00,11:00,12:00,13:00,14:00,15:00,16:00,17:00").split(",");
export const DAILYAVAILABLETIME = [
    {day:"Monday", time:TIMEDATA, dow:1},
    {day:"Tuesday", time:TIMEDATA, dow:2},
    {day:"Wednesday", time:TIMEDATA, dow:3},
    {day:"Thursday", time:TIMEDATA, dow:4},
    {day:"Friday", time:TIMEDATA, dow:5},
    {day:"Saturday", time:TIMEDATA, dow: 6},
    {day:"Sunday", time:TIMEDATA, dow: 0},
    
];

export const WAITINGGIF =  "<img src=\"/css/whatsappapi/waiting.gif\" style=\"width:23px;\">";

export async function getdata(payload:any, url="/appdata") {
    let token = APPUSER.user.token;
  
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify(payload)
    });
    if (response.status == 403) {      
      localStorage.setItem(APPSETTING.appname + "user", null);
      document.location.href = "/login";
      return null;
    }
    const data = await response.json();
    return data; 
}

export async function getdatanoauth(payload:any) {
    //let token = APPUSER.user.token;
  
    const response = await fetch("/appdatanoauth", {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload)
    });

    const data = await response.json();
    return data; 
}

export async function updatedata(payload:any, url="/updateappdata") {
    let token = APPUSER.user.token;
    //console.log("toke" + token);
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify(payload)
    });
    const data = await response.json();
    return data; 
}

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export const formatdate = (date) => {
  const day = String(date.getDate()).padStart(2, '0');
  const month = MONTHS[date.getMonth()];
  const year = date.getFullYear();
  return `${month} ${day} ${year}`;
};

export const getdate = (datestr) => {
  if (!datestr) return "";
  datestr = datestr.split(" ");

  const day = datestr[1];
  let month = MONTHS.findIndex(item => item == datestr[0]) + 1;
  month = (month < 10 ? "0" : "") + month;
  const year = datestr[2];
  datestr = year + "-" + month + "-" + day;
  return {datestr:datestr, date:new Date(datestr)}
};


export async function deletedata(payload:any, oncomplete) {
    let token = APPUSER.user.token;
  
    const response = await fetch("/deleteappdata", {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify(payload)
    });
    if (response.status == 403) {      
      localStorage.setItem(APPSETTING.appname + "user", null);
      document.location.href = "/login";
      return null;
    }
    const data = await response.json();
    if (oncomplete) {
      oncomplete();
    }
}

// export async function sendwhatsappmessage(params) {
//   let phonenumber = params.receiverphonenumber.split(",");
//   let message = params.message;
//   let processdata = [];
//   for (let i=0; i < phonenumber.length;i++) {
//     const response = await fetch("http://localhost:3000/sendmessage", {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//         'Authorization': 'Bearer xxx'
//       },
//       body: JSON.stringify({
//         senderphonenumber: params.senderphonenumber, 
//         receiverphonenumber: phonenumber[i], 
//         message: message
//       })
//     });
//     const data = await response.json();
//     processdata.push({phonenumber:phonenumber[i], response:data});
//   }
// }

export async function sendwhatsappmessage(params) {
  let receiverphonenumber = params.receiverphonenumber;
  let message = params.message;
  let senderphonenumber = params.senderphonenumber;
  let token = APPUSER.user.token;

  const response = await fetch("/sendwhatsappmessage", {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token,
      },
      body: JSON.stringify({
        senderphonenumber: senderphonenumber, 
        receiverphonenumber: receiverphonenumber, 
        message: message,
        senderid: params.senderid
      })
    });
    const data = await response.json();
    return data;
}

export async function getwhatsappqr(phonenumber) {
  let token = APPUSER.user.token;

  const response = await fetch("/whatsappqr", {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify({phonenumber:phonenumber})
  });
  const data = await response.json();
  return data;
}